import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const DeviceContext = createContext({ mode: 'desktop', width: 1024 });

function resolveMode(width) {
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

export function DeviceProvider({ children }) {
  const getWidth = () => (typeof window === 'undefined' ? 1024 : window.innerWidth);
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    let frame = 0;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setWidth(window.innerWidth));
    };
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('orientationchange', update, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  const value = useMemo(() => ({ width, mode: resolveMode(width) }), [width]);
  return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>;
}

export function useDevice() {
  return useContext(DeviceContext);
}
